<template>
  <q-separator class="full-width q-mb-md" />
</template>
